import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { FirebaseAuthService } from './services/FirebaseAuthService';

const firebaseConfig = {
    apiKey: "AIzaSyDO2UEt4M0Mfby0mglkIk8tPG7jfZFOvto",
    authDomain: "ezrunpbra.firebaseapp.com",
    databaseURL: "https://ezrunpbra.firebaseio.com",
    projectId: "ezrunpbra",
    storageBucket: "ezrunpbra.appspot.com",
    messagingSenderId: "61367043216",
    appId: "1:61367043216:web:21b1f692f1d025b4a80415"
  };
  
firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();

// Enhanced sign-in function that captures OAuth tokens
export const signInWithGoogle = () => FirebaseAuthService.signInWithGoogleAndCaptureTokens();

export const signOut = async () => {
  FirebaseAuthService.clearCredentials(); // Clear stored tokens
  return auth.signOut();
};

export default firebase;
  